export const REWARDS_SET_REDEEMABLE = 'REWARDS_SET_REDEEMABLE';
export const REWARDS_UPDATE_REDEEMABLE = 'REWARDS_UPDATE_REDEEMABLE';
export const REWARDS_SET_TYPES = 'REWARDS_SET_TYPES';
export const REWARDS_UPDATE_TYPES = 'REWARDS_UPDATE_TYPES';
